const baseUrlObj = {
    staging: 'https://locallifeid.staging.kuaishou.com',
    prt: 'https://ll-id.prt.kuaishou.com/',
    prod: 'https://id.kuaishou.com',
};

// 账号中台域名
export const ssoBaseUrl = () => {
    // const hostname = window.location.hostname;
    // if (hostname.indexOf('prt') !== -1) {
    //     return baseUrlObj.prt;
    // }
    // @ts-ignore
    return baseUrlObj[process.env.net_env] || baseUrlObj.prod;
};
